// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--38F6g","secondary":"button-module--secondary--z4Vre"};